import Footer from '@/components/layout/Footer'
import TopBar from '@/components/layout/TopBar/page'
import VerticalNavigationBarPage from '@/components/layout/VerticalNavigationBar/page'
import type { ChildrenType } from '@/common/types/component-props'

const AdminLayout = ({ children }: ChildrenType) => {
  return (
    <>


      <div className="wrapper">
        <TopBar />
        {/* {
          menu.size == 'default' ? */}
            <VerticalNavigationBarPage />
            {/* :
            <Offcanvas className="offcanvas-backdrop fade show" onClick={toggleMobileMenu} >
              <VerticalNavigationBarPage />
            </Offcanvas>
        } */}
        <div className="page-content">
          <div className="container-fluid">
            {children}
          </div>
          <Footer />
        </div>
      </div>



    </>
  )
}

export default AdminLayout
